import { generatePDF as generateBankPDF } from "../components/Documents/Download/BankDetailsDownload";
import { generatePDF as generateComplianceAndOtherDocumentsPDF } from "../components/Documents/Download/ComplianceAndOtherDocumentsDownload";
import { generatePDF as generateGdprJobApplicationProcessingConsentForm } from "../components/Documents/Download/GdprJobApplicationProcessingConsentFormDownload";
import { generatePDF as generateGdprPolicy } from "../components/Documents/Download/GdprPolicyDownload";
import { generatePDF as generateHealthQuestionnairePDF } from "../components/Documents/Download/HealthQuestionnaireDownload";
import { generatePDF as generateLfuk48hrOptOutFormPDF } from "../components/Documents/Download/Lfuk48hrOptOutFormDownload";
import { generatePDF as generateLfukKidForPayeFormPDF } from "../components/Documents/Download/LfukKidForPayeDownload";
import { generatePDF as generateLfukRecruitmentServicesLimitedTermsOfEngagement } from "../components/Documents/Download/LfukRecruitmentServicesLimitedTermsOfEngagementDownload";
import { generatePDF as generateLiteracyAndNumeracyAssessment } from "../components/Documents/Download/LiteracyNumeracyDownload";
import { generatePDF as generateNewStarterChecklist } from "../components/Documents/Download/NewStarterChecklistDownload";
import { generatePDF as generateWorkExperience } from "../components/Documents/Download/WorkExperienceDownload";
import { downloadFiles } from "./downloadFiles";

// Mapping document keys to their respective PDF generators
const documentGenerators = {
  bankDetails: generateBankPDF,
  complianceAndOtherDocuments: generateComplianceAndOtherDocumentsPDF,
  gdprJobApplicationProcessingConsentForm: generateGdprJobApplicationProcessingConsentForm,
  gdprPolicy: generateGdprPolicy,
  healthQuestionnaire: generateHealthQuestionnairePDF,
  lfuk48hrOptOutForm: generateLfuk48hrOptOutFormPDF,
  lfukKidForPaye: generateLfukKidForPayeFormPDF,
  lfukRecruitmentServicesLimitedTermsOfEngagement: generateLfukRecruitmentServicesLimitedTermsOfEngagement,
  literacyAndNumeracyAssessment: generateLiteracyAndNumeracyAssessment,
  newStarterChecklist: generateNewStarterChecklist,
  workExperience: generateWorkExperience,
};

// Function to generate PDFs for a batch of documents
const batchGeneratePDFs = async (batch, obj, sasToken) => {
  for (const item of batch) {
    if (item.progress === 100) {
      const generatePDF = documentGenerators[item.key];

      if (generatePDF) {
        try {
          await generatePDF(item, obj["userDetail"], sasToken);
        } catch (error) {
          console.error(`Error generating PDF for ${item.key}:`, error);
        }
      } else {
        console.warn(`No handler found for key: ${item.key}`);
      }
    }
  }
};

// Retry function with exponential backoff
const retryDownload = async (func, retries = 3, delay = 1000) => {
  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      await func();
      return;
    } catch (error) {
      console.error(`Attempt ${attempt} failed. Retrying in ${delay}ms...`, error);
      if (attempt === retries) {
        console.error("Max retry attempts reached. Download failed.");
      } else {
        await new Promise((resolve) => setTimeout(resolve, delay));
        delay *= 2; // Exponential backoff
      }
    }
  }
};

export const downloadAllDocuments = async (obj, sasToken) => {
  try {
    const items = Object.values(obj).filter((item) => item.progress === 100);
    const batchSize = Math.min(5, Math.ceil(items.length / 2)); // Adjust batch size dynamically

    for (let i = 0; i < items.length; i += batchSize) {
      const batch = items.slice(i, i + batchSize);
      await retryDownload(() => batchGeneratePDFs(batch, obj, sasToken));
    }
    await downloadFiles(obj, sasToken);
    console.log("All documents downloaded successfully!");
  } catch (error) {
    console.error("Unexpected error in document download process:", error);
  }
};
